<template>
  <div>
    <loading v-if="!alreadyLoaded" full-screen="false" size="small" />

    <div v-else>
      <div>
        <ol class="breadcrumb">
          <li>
            <router-link to="/instituicoes">
              Instituições
            </router-link>
          </li>

          <li class="active">
            {{ institution.name }} - {{ institution.display_id }}
          </li>
        </ol>
      </div>

      <page-header>
        <template #title>
          {{ institution.name }}
        </template>
        <template #subheader>
          <h4 class="admin-subheader">
            {{ institution.group_name }}
          </h4>
        </template>
        <template #description>
          Configuração geral da instituição. Use as abas abaixo para
          editar regras de negócio (BRG), gerenciar recebedores e splits,
          configurar rematrícula, regras de acordo, contratos digitais e
          atualizações em lote.
        </template>
      </page-header>

      <ul class="nav nav-tabs">
        <router-link
          tag="li"
          role="presentation"
          class="nav-item"
          active-class="active"
          :to="{ name: 'business-rule-group' }"
        >
          <a>Regras de negócio (BRG)</a>
        </router-link>

        <router-link
          tag="li"
          role="presentation"
          class="nav-item"
          active-class="active"
          :to="{ name: 'recipients' }"
        >
          <a>Recebedores</a>
        </router-link>

        <router-link
          tag="li"
          role="presentation"
          class="nav-item"
          active-class="active"
          :to="{ name: 'reenrollment' }"
        >
          <a>Rematrícula</a>
        </router-link>

        <router-link
          tag="li"
          role="presentation"
          class="nav-item"
          active-class="active"
          :to="{ name: 'agreement-rules' }"
        >
          <a>Regras de acordo</a>
        </router-link>
        <router-link
          tag="li"
          role="presentation"
          class="nav-item"
          active-class="active"
          :to="{ name: 'digital-contracts' }"
        >
          <a>Contratos Digitais</a>
        </router-link>
        <router-link
          v-if="isFcvInstitution"
          tag="li"
          role="presentation"
          class="nav-item"
          active-class="active"
          :to="{ name: 'update-fcv-billings-with-jacad-in-batch' }"
        >
          <a>Atualizar conforme Jacad</a>
        </router-link>
      </ul>

      <router-view />
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import Loading from 'components/Loading';

export default {
  components: {
    Loading,
  },
  computed: {
    ...mapState([
      'institution',
    ]),
    alreadyLoaded() {
      return this.institution;
    },
    isFcvInstitution() {
      return this.institution.id === 2999;
    },
  },
  mounted() {
    this.loadInstitution(this.$route.params.id);
  },
  methods: {
    ...mapActions([
      'loadInstitution',
    ]),
  },
};
</script>
